import { Link } from 'react-router-dom'

const REPORT_LINKS = [
  { to: '/sales', label: 'Daily / monthly sales', hint: 'Summary tab' },
  { to: '/sales', label: 'Payment mix', hint: 'On sales summary' },
  { to: '/sales', label: 'Staff commission', hint: 'Staff commission tab' },
  { to: '/sales', label: 'Ticket history & refunds', hint: 'History / Refunds tabs' },
  { to: '/cash', label: 'Cash day / Z-reports', hint: 'Open · expenses · day end · print Z' },
  { to: '/products', label: 'Inventory & purchases', hint: 'Products · Purchase · Low stock' },
  { to: '/packages', label: 'Package usage', hint: 'Session packs' },
  { to: '/calendar', label: 'Appointments', hint: 'Day / week schedule' },
]

export function ReportsHubPanel() {
  return (
    <div className="mt-6 space-y-4">
      <h2 className="text-lg font-semibold">More reports</h2>
      <p className="text-sm text-muted-foreground">
        Plain-language links — no 80-report maze. VAT appears on receipts and Z-reports.
      </p>
      <ul className="grid gap-3 sm:grid-cols-2">
        {REPORT_LINKS.map((item) => (
          <li key={`${item.to}-${item.label}`}>
            <Link
              to={item.to}
              className="block rounded-2xl border border-border/70 bg-card px-4 py-3 transition hover:border-primary/40"
            >
              <p className="font-medium text-foreground">{item.label}</p>
              <p className="text-xs text-muted-foreground">{item.hint}</p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
